<template>
    <div class="container mt-0 mb-4">
      <div class="card shadow-sm p-4 bg-light">

       <div class="d-flex align-items-center mb-4">

<button class="btn btn-outline-secondary me-3" @click="volver">
  ← Regresar
</button>
<h3 class="m-0 flex-grow-1 text-center">Registrar Check-Out</h3>

</div>

        <!-- Datos del huésped -->
        <div v-if="reserva" class="mb-4">
          <h5 class="mb-3">Datos del Huésped</h5>
          <p><strong>Nombre:</strong> {{ reserva.huesped?.Nombre }} {{ reserva.huesped?.Apellido }}</p>
          <p><strong>DPI:</strong> {{ reserva.huesped?.DPI }}</p>
          <p><strong>Teléfono:</strong> {{ reserva.huesped?.Telefono }}</p>
          <p><strong>NIT:</strong> {{ reserva.huesped?.NIT }}</p>
        </div>

        <!-- Habitaciones -->
        <div v-if="reserva">
          <h5 class="mb-3">Habitaciones Reservadas</h5>
          <div
            v-for="hab in reserva.habitaciones_reservadas"
            :key="hab.IdReservaHabitacion"
            class="card mb-3 shadow-sm"
          >
            <div class="card-body">
              <p><strong>Habitación:</strong> {{ hab.habitacion?.Numero }} ({{ hab.habitacion?.tipo?.Nombre }})</p>
              <p><strong>Personas alojadas:</strong> {{ hab.CantidadPersonasAlojadas }}</p>

              <div class="form-check form-switch mb-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="checkOutSeleccionado[hab.IdReservaHabitacion]"
                  :id="'checkOut_' + hab.IdReservaHabitacion"
                  :disabled="hab.CheckOut !== null"
                />
                <label class="form-check-label" :for="'checkOut_' + hab.IdReservaHabitacion">
                  Confirmar Check-Out
                </label>
              </div>

              <p class="text-muted" v-if="hab.CheckOut">
                Check-Out realizado: {{ hab.CheckOut }}
              </p>

              <button
                class="btn w-100"
                :class="hab.CheckOut ? 'btn-danger disabled' : 'btn-success'"
                :disabled="hab.CheckOut || !checkOutSeleccionado[hab.IdReservaHabitacion]"
                @click="realizarCheckOut(hab.IdReservaHabitacion)"
              >
                {{ hab.CheckOut ? 'Check-Out Realizado' : 'Realizar Check-Out' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div class="modal fade show d-block" tabindex="-1" role="dialog" v-if="modalVisible" style="background-color: rgba(0, 0, 0, 0.5);">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content bg-white shadow">
            <div class="modal-header">
              <h5 class="modal-title">Check-Out</h5>
              <button type="button" class="btn-close" @click="cerrarModal"></button>
            </div>
            <div class="modal-body">
              <p>{{ mensajeCheckOut }}</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" @click="cerrarModal">Aceptar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import axios from 'axios'
  import { API_URL } from '@/config/config.js'
  import { useRoute } from 'vue-router'

  export default {
    name: 'checkOutHabitaciones',
    data() {
      return {
        reserva: null,
        modalVisible: false,
        mensajeCheckOut: '',
        checkOutSeleccionado: {}
      }
    },
    async mounted() {
      const id = useRoute().params.id
      const res = await axios.get(`${API_URL}/reservas/${id}`)
      this.reserva = res.data.reserva

      // Inicializar switches
      this.reserva.habitaciones_reservadas.forEach(hab => {
        this.checkOutSeleccionado[hab.IdReservaHabitacion] = false
      })
    },
    methods: {
      async realizarCheckOut(id) {
  // Buscar la habitación específica
  const habitacion = this.reserva.habitaciones_reservadas.find(
    h => h.IdReservaHabitacion === id
  );

  // Validación 1: Debe tener Check-In
  if (!habitacion || !habitacion.CheckIn) {
    this.mensajeCheckOut = 'No se puede realizar el check-out. Primero debe realizar el check-in.';
    this.modalVisible = true;
    return;
  }

  // Validación 2: Saldo pendiente debe ser 0
  const saldoPendiente = Number(this.reserva?.SaldoPendiente);
  if (saldoPendiente > 0) {
    this.mensajeCheckOut = `No se puede realizar el check-out. La reserva aún tiene un saldo pendiente de Q.${saldoPendiente.toFixed(2)}`;
    this.modalVisible = true;
    return;
  }

  try {
    const res = await axios.put(`${API_URL}/reservas-habitacion/checkout/${id}`);
    const nueva = await axios.get(`${API_URL}/reservas/${this.reserva.IdReserva}`);
    this.reserva = nueva.data.reserva;
    this.mensajeCheckOut = res.data.message;
    this.modalVisible = true;
  } catch (error) {
    console.error('Error en checkout:', error);
    this.mensajeCheckOut = error.response?.data?.message || 'Error al realizar el check-out.';
    this.modalVisible = true;
  }
},
   volver() {

this.$router.push('/reservas')

},
      cerrarModal() {
        this.modalVisible = false
      }
    }
  }
  </script>

  <style scoped>
  label {
    font-weight: 500;
  }
  </style>
